module.exports = __webpack_public_path__ + "media/images/custom_link-821232d7fcd40ebb0e7718e44043a0ce.svg";